import React, { useEffect, useState } from "react";
import "./DivFilter.css";

function DivFilter({ toFilter, search, children }) {
  const [filteredResult, setFilteredResult] = useState();
  const [displayFilters, showDisplayFilters] = useState(true);
  useEffect(() => {
    const temp = [];
    toFilter &&
      toFilter.forEach((val) => {
        Object.keys(val).map((i) => {
          if (i.includes(search)) {
            temp.push(i);
          }
        });
      });

    if (search.length === 0) {
      setFilteredResult([]);
      showDisplayFilters(true);
    } else {
      setFilteredResult(temp);
    }
  }, [search]);

  const handleHideClose = () => {
    showDisplayFilters(false);
  };

  return (
    <div className="inherit_style">
      <div>{children}</div>

      {displayFilters && (
        <div
          className="linkfamily_modal_container__label"
          style={{ color: "black" }}
        >
          {filteredResult &&
            search.length !== 0 &&
            filteredResult.length !== 0 && (
              <div className="divfilter_mainFloat_div">
                <div className="divfilter_mainFloat_div_result_title_div">
                  <p className="divfilter_mainFloat_div_result_title">
                    You can use this instead !
                  </p>

                  <p
                    className="divfilter_mainFloat_div_result_closeFilters"
                    onClick={() => handleHideClose()}
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </p>
                </div>
                {filteredResult.map((i) => (
                  <p className="divfilter_mainFloat_div_results">{i}</p>
                ))}
              </div>
            )}
        </div>
      )}
    </div>
  );
}

export default DivFilter;
